import { render } from "./InformacoesImovel.vue?vue&type=template&id=38cba48c"
import script from "./InformacoesImovel.vue?vue&type=script&lang=js"
export * from "./InformacoesImovel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__